export default class DisplayHandler {
  constructor({type, container}) {
    this.type = type;
    this.$container = $(container);
  }
  handle() {
    this.handleDisplayFor17();
  }
  handleDisplayFor17() {
    this.hideMailAlert17();
    this.hideProductAvailability17();
    this.unlockAddToCartBtn17();
  }
  hideMailAlert17() {
    const $mailAlertBox = this.$container.find(".js-mailalert-contianer");
    if ($mailAlertBox.length === 0) {
      return;
    }
    $mailAlertBox.hide();
  }
  hideProductAvailability17() {
    const $availability = this.$container.find("#product-availability");
    $availability.length && $availability.hide();
  }
  unlockAddToCartBtn17() {
    const $btn = this.$container.find('[data-button-action="add-to-cart"]');
    $btn.length && $btn.removeAttr("disabled");
  }
}
